import React from 'react'
import BlogPost from './BlogPost'

export default function MemoryOfSeason() {
  return (
    <BlogPost
      translationKey="memoryOfSeason"
      seoTitle="계절의 기억 | Hyunjin Jae"
      seoDescription="계절과 기억, 그리고 마음에 대한 짧은 생각입니다."
      seoKeywords="계절, 기억, 추억, season, memory, reflection"
      seoTags={['season', 'memory', 'reflection']}
    />
  )
}
